import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import {Button, Dropdown, Menu} from "antd";
export default class MenuButton extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};


    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let btnList = this.props.btnList;
        let menu = (<Menu>{
                btnList && btnList.length && btnList.map((item, index) => {
                    return <Menu.Item key={item.name} onClick={()=>{
                        this.props.menuListOnclick&&this.props.menuListOnclick(btnList[index])
                    }}>{item.name}</Menu.Item>
                })
            }
            </Menu>
        );
        return (
            <Dropdown overlay={menu}>
                <Button style={{marginLeft: -4}} type={ this.props.type}>{this.props.name}</Button>
            </Dropdown>

        )
    }
}